import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { Logo } from "./Logo";

export const Nav = () => {
  const { count, setIsOpen } = useCart();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      className="sticky top-0 z-40 w-full bg-[#f0e9e1]/85 backdrop-blur-md border-b border-[#1a1814]/10"
      data-testid="site-nav"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 h-16 sm:h-20 flex items-center justify-between gap-6 sm:gap-4">
        <nav className="flex items-center gap-4 sm:gap-6 lg:gap-8 flex-1 min-w-0">
          <Link to="/shop" className="micro-label text-[#1a1814] hover:opacity-60" data-testid="nav-shop">
            Shop
          </Link>
          <Link to="/shop?category=lounge" className="micro-label text-[#1a1814] hover:opacity-60 hidden md:inline" data-testid="nav-lounge">
            Lounge
          </Link>
          <Link to="/shop?category=active" className="micro-label text-[#1a1814] hover:opacity-60 hidden md:inline" data-testid="nav-active">
            Active
          </Link>
          <Link to="/fit-quiz" className="micro-label text-[#1a1814] hover:opacity-60 hidden md:inline" data-testid="nav-fit-quiz">
            Find Your Fit
          </Link>
          <Link to="/about" className="micro-label text-[#1a1814] hover:opacity-60" data-testid="nav-about">
            Atelier
          </Link>
        </nav>

        <Link to="/" className="flex-shrink-0" data-testid="nav-home-logo">
          <Logo size="sm" />
        </Link>

        <div className="flex-1 flex items-center justify-end gap-4 sm:gap-6">
          <button
            type="button"
            className="micro-label text-[#1a1814] hover:opacity-60 hidden lg:block"
            data-testid="nav-search"
            aria-label="Search"
          >
            Search
          </button>
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="flex items-center gap-1.5 sm:gap-2 micro-label text-[#1a1814] hover:opacity-60"
            data-testid="nav-cart-trigger"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-4 h-4" strokeWidth={1.25} />
            <span data-testid="nav-cart-count">({count})</span>
          </button>
        </div>
      </div>
      {isHome && (
        <div className="bg-[#1a1814] text-[#f0e9e1] overflow-hidden">
          <div className="flex whitespace-nowrap marquee py-2 micro-label text-[10px]">
            {["a", "b"].map((slot) => (
              <div key={`marquee-${slot}`} className="flex shrink-0 gap-12 pr-12">
                <span>Founders' Pricing · First 100 customers</span><span>·</span>
                <span>Designed for women 5'9" and above</span><span>·</span>
                <span>Complimentary shipping over £85</span><span>·</span>
                <span>Tonal TIA embroidery on every heritage piece</span><span>·</span>
                <span>Inseams to 34"</span><span>·</span>
                <span>Founders' Pricing · First 100 customers</span><span>·</span>
                <span>Designed for women 5'9" and above</span><span>·</span>
                <span>Complimentary shipping over £85</span><span>·</span>
                <span>Tonal TIA embroidery on every heritage piece</span><span>·</span>
                <span>Inseams to 34"</span><span>·</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
